// MF-566 — Picks ONE student of the school for a Board (staff only): the Board Builder previews and
// the Board viewer then draw every tile for that student instead of the whole school. Searches the
// roster of the school (the same one the Board reads) by name or student code, so whoever is picked
// always has data. Value: { code, label } | null.
import { useEffect, useRef, useState } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { searchBoardStudents } from '../../../../services/boards/boards.service'

// One roster row → the picker option. The CODE is what the Board is scoped by.
export const studentOption = (r) => ({
  code: String(r.code),
  label: `${r.name || r.code}${r.year_level ? ` · ${/year/i.test(r.year_level) ? r.year_level : `Year ${r.year_level}`}` : ''} (${r.code})`
})

const StudentSelect = ({ value, onChange, label = 'Student', area = 'library', sx }) => {
  const [input, setInput] = useState('')
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const timer = useRef(null)

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current)
    const term = input.trim()
    if (term.length < 2 || (value && term === value.label)) {
      setOptions([])
      return undefined
    }
    timer.current = setTimeout(async () => {
      setLoading(true)
      try {
        const rows = await searchBoardStudents(term, area).catch(() => [])
        setOptions(rows.map(studentOption))
      } finally {
        setLoading(false)
      }
    }, 300)
    return () => timer.current && clearTimeout(timer.current)
  }, [input, value, area])

  return (
    <Autocomplete
      size='small'
      sx={{ minWidth: 260, ...sx }}
      loading={loading}
      options={options}
      value={value || null}
      filterOptions={(x) => x}
      getOptionLabel={(o) => o.label}
      isOptionEqualToValue={(a, b) => a.code === b.code}
      inputValue={input}
      onInputChange={(_, v) => setInput(v)}
      onChange={(_, v) => onChange(v || null)}
      noOptionsText={input.trim().length < 2 ? 'Type a name or code…' : 'No students found'}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder='Whole school — search a student…' />
      )}
    />
  )
}

export default StudentSelect
